import { NavLink } from 'react-router-dom';
import './ChildSubnav.css';

interface ChildSubnavProps {
  childId: string;
}

/**
 * Three-tab navigation across a child's parent-side surfaces:
 * detail (radar + goals + summary), highlights, and AI note. Each
 * page uses the same shell — this nav lets a parent move between
 * them without going back to /parent.
 */
export function ChildSubnav({ childId }: ChildSubnavProps) {
  const tabs: Array<{ to: string; label: string; end?: boolean }> = [
    { to: `/parent/child/${childId}`, label: 'Progress', end: true },
    { to: `/parent/child/${childId}/highlights`, label: 'Highlights' },
    { to: `/parent/child/${childId}/ai-note`, label: 'AI note' },
  ];

  return (
    <nav className="child-subnav" aria-label="Child views">
      {tabs.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end={t.end}
          className={({ isActive }) =>
            `child-subnav__tab${isActive ? ' child-subnav__tab--active' : ''}`
          }
        >
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}
